// extracted by mini-css-extract-plugin
export default {"overlay":"hx-z","bodyOpen":"ix-z","content":"jx-z","header":"kx-z","close":"lx-z","closeNoHeading":"mx-z"};